import { render } from "./orders_charge.vue?vue&type=template&id=277f72f0"
import script from "./orders_charge.vue?vue&type=script&lang=js"
export * from "./orders_charge.vue?vue&type=script&lang=js"

import "./orders_charge.vue?vue&type=style&index=0&id=277f72f0&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__